import React from 'react'

import ColumnGridPanel from 'components/ColumnGridPanel'
import { furnaceReport } from 'types/SystemStatusReport'

const FurnaceReport = ({ report }: furnaceReport) => {
  return (
    <>
      <ColumnGridPanel.Column.Item label="Demand" value={report.extendedIndoorFurnaceDemandStatus} hideIfValueIsNull />
      <ColumnGridPanel.Column.Item label="Furnace Operation Mode" value={report.extendedIndoorFurnaceOperationMode} hideIfValueIsNull />
      <ColumnGridPanel.Column.Item label="Inducer Error Handling" value={report.extendedIndoorFurnaceInducerErrorHandling} hideIfValueIsNull />
      <ColumnGridPanel.Column.Item label="Unit Orientation" value={report.extendedIndoorFurnaceUnitOrientation} hideIfValueIsNull />
      <ColumnGridPanel.Column.Item label="Inducer Stage" value={report.extendedIndoorFurnaceInducerStage} hideIfValueIsNull />
      <ColumnGridPanel.Column.Item label="Gas Valve Status" value={report.extendedIndoorFurnaceGasValveStatus} hideIfValueIsNull />

      <ColumnGridPanel.Column.Item label="Pressure Switch 1" value={report.pressureSwitchOne} hideIfValueIsNull />
      <ColumnGridPanel.Column.Item label="Pressure Switch 2" value={report.pressureSwitchTwo} hideIfValueIsNull />

      <ColumnGridPanel.Column.Item label="High Limit" value={report.highLimitStatus} hideIfValueIsNull />
      <ColumnGridPanel.Column.Item label="Inducer Limit" value={report.inducerLimitStatus} hideIfValueIsNull />
      <ColumnGridPanel.Column.Item label="Condensate" value={report.condensateStatus} hideIfValueIsNull />
      <ColumnGridPanel.Column.Item label="Ignitor" value={report.ignitorStatus} hideIfValueIsNull />
      <ColumnGridPanel.Column.Item label="Rollout Limit Input" value={report.rolloutLimitInputStatus} hideIfValueIsNull />
      <ColumnGridPanel.Column.Item label="Reverse Airflow" value={report.reverseAirflowStatus} hideIfValueIsNull />
      <ColumnGridPanel.Column.Item label="Flame" value={report.flameStatus} hideIfValueIsNull />
      <ColumnGridPanel.Column.Item label="Accessory 1" value={report.accessoryOneStatus} hideIfValueIsNull />
      <ColumnGridPanel.Column.Item label="Accessory 2" value={report.accessoryTwoStatus} hideIfValueIsNull />
    </>
  )
}

export default FurnaceReport
